import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    borderRadius  : 4,
    paddingLeft   : 10,
    paddingRight  : 10,
    paddingTop    : 10,
    paddingBottom : 10,
    width         : 300,
    marginTop     : 100,
  },
  header: {
    flexDirection  : "row",
    alignItems     : "center",
    justifyContent : "space-between",
  },
  timezone: {
    flexDirection : "row",
    alignItems    : "center",
    marginLeft    : 10,
  },
  options: {
    width          : 30,
    height         : 30,
    justifyContent : "center",
    alignItems     : "center",
  },
  photo: {
    alignItems   : "center",
    marginTop    : 20,
    marginBottom : 20,
  },
  changePhotoButton: {
    position        : "absolute",
    bottom          : -10,
    backgroundColor : "#FFF",
    width           : 30,
    height          : 30,
    borderRadius    : 999,
    justifyContent  : "center",
    alignItems      : "center",
  },
  details: {
    marginTop    : 15,
    marginBottom : 15,
    marginRight  : 15,
    marginLeft   : 15,
  },
  detail: {
    marginTop    : 7,
    marginBottom : 7,
  },
  roleButton: {
    alignSelf     : "center",
    borderRadius  : 6,
    alignItems    : "center",
    paddingTop    : 3,
    paddingBottom : 3,
    paddingLeft   : 10,
    paddingRight  : 10,
  },
  avatar: {
    width          : 100,
    height         : 100,
    borderRadius   : 9999,
    justifyContent : "center",
    alignItems     : "center",
  },
});
